module.exports = __webpack_public_path__ + "img/XAI3.21cda342.jpg";